import { MemberId, TopSpecialistListItemsById, TopSpecialistsList, TopSpecialistsListItem, TopSpecialistsListItemIds } from '@types';
import { appCreateSelector, RootState } from '@store';
import { TopSpecialistsState } from '@slices/top-specialists';

/**
 * regular selectors
 */

export const topSpecialistsGet = (state: RootState): TopSpecialistsState => {
  return state.app.topSpecialists;
};

/**
 * memoized reselect selectors
 */

export const topSpecialistsGetListItemIds: (state: RootState) => TopSpecialistsListItemIds = appCreateSelector([topSpecialistsGet], topSpecialists => topSpecialists.listItemIds);
export const topSpecialistsGetListItemsById: (state: RootState) => TopSpecialistListItemsById = appCreateSelector([topSpecialistsGet], topSpecialists => topSpecialists.listItemsById);
export const topSpecialistsGetListHasMore: (state: RootState) => boolean = appCreateSelector([topSpecialistsGet], topSpecialists => topSpecialists.hasMore);
export const topSpecialistsGetListLimit: (state: RootState) => number = appCreateSelector([topSpecialistsGet], topSpecialists => topSpecialists.limit);
export const topSpecialistsGetListOffset: (state: RootState) => number = appCreateSelector([topSpecialistsGet], topSpecialists => topSpecialists.offset);
export const topSpecialistsGetListTotalCount: (state: RootState) => number = appCreateSelector([topSpecialistsGet], topSpecialists => topSpecialists.totalCount);
export const topSpecialistsGetListItemById: (state: RootState, id: MemberId) => TopSpecialistsListItem = appCreateSelector([topSpecialistsGetListItemsById, (_state, id: MemberId) => id], (topSpecialists, id) => topSpecialists[id]);
export const topSpecialistsGetList: (state: RootState) => TopSpecialistsList = appCreateSelector([topSpecialistsGetListItemIds, topSpecialistsGetListHasMore, topSpecialistsGetListLimit, topSpecialistsGetListOffset, topSpecialistsGetListTotalCount, (state: RootState) => state], (topSpecialistsIds, hasMore, limit, offset, totalCount, state) => {
  const items = topSpecialistsIds.map(id => topSpecialistsGetListItemById(state, id));
  return {
    items,
    hasMore,
    limit,
    offset,
    totalCount
  };
});